/**
 * jockey__cheniu module
 * @module
 */

const Jockey = window.Jockey;

/** @type {Object} */
module.exports = {
	/**
	 * 获取用户基本信息
	 */
	getUser: function () {
		var d = $.Deferred();
		Jockey.send('UserBridge', function(data) {
			/* data数据结构
		     * {
		     *      userPhone: 13732262222  //用户当前手机号
		     *      userId: 13732262509     //用户登录账号
		     *      userName: 张三        //用户姓名
		     *      userToken: sadfjl99809asflaskdf80sadf9    //用户token
		     *      userSign: userId的MD5值
		     * }
		     */
		    if (data) {
		    	d.resolve(data);
		    }
		});
		return d;
	},
	/**
	 * 获取 App 核心数据
	 */
	getCore: function () {
		var d = $.Deferred();
		Jockey.send('CoreBridge', function(data) {
			/* data数据结构
		     * {
		     *      version: 1  //获取当前bridge版本号，目前为1 
		     *      platform: 'appStore'  //所在平台，iOS：appStore，Android：Android
		     *      env: 1      //获取app当前环境，0测试环境，1生产环境，2预发环境 
		     *      nodeHost: 'http://niu.souche.com'  //获取node环境的host
		     *      rubyHost: 'http://paimaiadmin.souche.com'  //获取ruby环境的host
		     *      JavaHost: '...' //获取java环境的host
		     *      htmlHost: 'http://cheniu-h5.souche.com'  //获取前端环境的host
		     *      newHtmlHost: 'http://f2e-assets.souche.com'  //获取新的前端环境的host
		     *      AppId: 'cheniuAppStore'  //App的唯一标识符
		     *      AppBuild: '...' //获取当前app build 
		     *      AppVersion: '...' //获取当前app version
		     * }
		     */
			d.resolve(data);
		});
		return d;
	},
	/**
	 * 设置标题
	 */
	setWebViewTitle: function (title) {
		Jockey.send("SetWebViewTitle",{
			title: title
		}, function(data) {

		});
	},
	/**
	 * 打开一个新的 WevView
	 */
	open: function (url) {
		this.openWithOnClose(url, function (data) {
			if (data.refresh) {
				window.location.reload();
			}
		});
	},
	/** 打开一个新的 WevView, 并监听关闭 */
	openWithOnClose: function (url, callback) {
		Jockey.send('PushWebVCBridge', {    
		    url: 'https://f2e-assets.souche.com/jump?redirect=' + encodeURIComponent(url)
		}, function (data) {
			if (data.event == 'close') {
				callback(data);
			}
		});
	},
	/**
	 * 关闭当前 WebvView
	 */
	close: function (callLaster) {
		Jockey.send('TriggleWebVCCallbackBridge', {
			//此对象为传回给A页面的数据
			refresh: callLaster,
			event: 'close'
		}, function() {
		     	//接收到数据后执行的回调，默认动作为关闭本页面回到上一个页面，并把数据带回上一个页面
		        Jockey.send('ControlWebVCBridge', {
		             action: 'close'
		        });
		    }
		 );
	},
	/**
	 * 关闭并打开
	 */
	// closeThenOpen: function (url) {
	// 	return this._popAndPushVC({
	// 		protocol: url
	// 	});
	// },
	/**
	 * 跨 WebView 双向通信
	 */
	
	/**
	 * 唤起拍照和选择图片控件
	 */
	capturePic: function (n, pickerType) {
		var d = $.Deferred();
		Jockey.send('CapturePicBridge', {
		    maxPicCount: n,
		    pickerType: pickerType || 'normal'
		}, function(data) { 
		    /* 照片上传完毕后执行此回调，data内存放照片数据
		     *  {
		     *      urls: ['http://img.souche.com/20160112/png/0.png']   
		     *  }
		     */
		    d.resolve(data);
		});  
		return d;
	},
	/** 唤起拍照 */
	picFromCamera: function () {
		return this.capturePic(1, 'camera');
	},
	/** 唤起选择图片 */
	picFromAlbum: function () {
		return this.capturePic(1, 'album');
	},

	/** 剪裁图片 */
	cutImage: function (img, w, h) {
		var d = $.Deferred();
		Jockey.send('CutImageBridge', {
			width: (w + '') || '750',
			height: (h + '') || '320',
			imageUrl: img
		}, function (data) {
			d.resolve(data);
		});
		return d;
	},

	/**
	 * 预览图片
	 */
	browsePic: function (i, pics, enableDelete) {
		Jockey.send('BrowsePicBridge', {
		    //当前预览图片的序号
		    index: i,
		    //预览图片的数组
		    pics: pics,
		    // bool类型，是否可以做删除操作
		    enableDelete: enableDelete
		}) 
	},
	/**
	 * 原生弹出框
	 */
	alert: function (title, message, cancel, other) {
		var d = $.Deferred();
		Jockey.send('AlertBridge', {
		    title: title,  //选填
		    message: message,  //选填
		    cancel: cancel? '是': '否', //弹出框左边的按钮
		    other: other? '是': '否', //弹出框右边的按钮
		}, function(data) {
		    /*
		     *  data.action = 0   点击左边的按钮
		     *  data.action = 1   点击右边的按钮
		     */
		    d.resolve(data);
		});
		return d;
	},
	/**
	 * 原生车型库
	 */
	carSelector: function (level, hot) {
		Jockey.send('CarSelectorBridge', {
		    level: level,   // level=1表示精确到品牌，level=2表示精确到车型，level=3表示精确到车系
		    hot: hot,  // 是否显示热门品牌，注：Android只在level=3的时候才会显示热门品牌，当level=1或2时此项可不填或者统一置为false
		}, function(data) {
		    /*
		     *  data的数据结构
		     *
		     *  level = 1
		     *      选择“奥迪”品牌
		     *          {
		     *              selected: [
		     *                  {
		     *                      code: 'brand-15',
		     *                      name: '奥迪',
		     *                      logo: 'http://img.souche.com/files/carproduct/brand/brand-15.png',
		     *                      displayName: '奥迪'     //注：displayName字段只在iOS中存在，对前端没有价值，iOS的返回值中都会带有此字段
		     *                  }
		     *              ]
		     *          }
		     *
		     *      选择不限品牌
		     *          {
		     *              selected: [
		     *                  {
		     *                      code: '',
		     *                      name: ''
		     *                  }
		     *              ]
		     *          }
		     *          注：选择不限品牌时，
		     *              iOS实际返回的数据结构为
		     *                  {
		     *                      selected: [
		     *                          {
		     *                              displayName: '不限品牌',
		     *                              code: '',
		     *                              name: ''
		     *                          }
		     *                      ]
		     *                  }
		     *              Android实际返回的数据结构为
		     *                  {
		     *                      selected: [{}]
		     *                  }
		     *
		     *
		     *  level = 2
		     *      选择“奥迪”->“奥迪A4L”
		     *          {
		     *              selected: [
		     *                  {
		     *                      code: 'brand-15',
		     *                      name: '奥迪',
		     *                      logo: 'http://img.souche.com/files/carproduct/brand/brand-15.png',
		     *                      selectedRows: [
		     *                          {
		     *                              code: 'series-621',
		     *                              name: '奥迪A4L',
		     *                              logo: 'http://img.souche.com/files/carproduct/series/series-621.png'
		     *                          }
		     *                      ]
		     *                  }
		     *              ]
		     *          }
		     *      选择“奥迪”“不限车系”
		     *          {
		     *              selected: [
		     *                  {
		     *                      code: 'brand-15',
		     *                      name: '奥迪',
		     *                      logo: 'http://img.souche.com/files/carproduct/brand/brand-15.png',
		     *                      selectedRows: [
		     *                          {
		     *                              code: 'brand-15',
		     *                              name: '奥迪',
		     *                              logo: 'http://img.souche.com/files/carproduct/brand/brand-15.png'
		     *                          }
		     *                      ]
		     *                  }
		     *              ]
		     *          }
		     *
		     *
		     *  level = 3
		     *      选择“奥迪”->“奥迪A4L”->“2016款 奥迪A4L 45 TFSI quattro运动型”
		     *          {
		     *              selected: [
		     *                  {
		     *                      code: 'brand-15',
		     *                      name: '奥迪',
		     *                      logo: 'http://img.souche.com/files/carproduct/brand/brand-15.png',
		     *                      selectedRows: [
		     *                          {
		     *                              code: 'series-621',
		     *                              name: '奥迪A4L',
		     *                              logo: 'http://img.souche.com/files/carproduct/series/series-621.png',
		     *                              selectedRows: [
		     *                                  {
		     *                                      coee: '7919-n',
		     *                                      name: '2016款 奥迪A4L 45 TFSI quattro运动型'
		     *                                  }
		     *                              ]
		     *                          }
		     *                      ]
		     *                  }
		     *              ]
		     *          }
		     *      选择“奥迪”->“奥迪A4L”->“不限车型”
		     *          {
		     *              selected: [
		     *                  {
		     *                      code: 'brand-15',
		     *                      name: '奥迪',
		     *                      logo: 'http://img.souche.com/files/carproduct/brand/brand-15.png',
		     *                      selectedRows: [
		     *                          {
		     *                              code: 'series-621',
		     *                              name: '奥迪A4L',
		     *                              logo: 'http://img.souche.com/files/carproduct/series/series-621.png',
		     *                              selectedRows: [
		     *                                  {
		     *                                      code: 'series-621',
		     *                                      name: '奥迪A4L',
		     *                                  }
		     *                              ]
		     *                          }
		     *                      ]
		     *                  }
		     *              ]
		     *          }
		     */
		});
	},
	/**
	 * 分享
	 */
	showShare: function () {
		Jockey.send('ControlWebVCBridge',  {
		    action: 'ShowShare'
		});
	},
	hideShare: function () {
		Jockey.send('ControlWebVCBridge',  {
		    action: 'hideShare'
		});
	},
	openShare: function () {
		Jockey.send('H5ShareBridge');
	},
	configShare: function (data) {
		var _data = {
			title: data.title,
	        content: data.desc,
	        url: data.link,
	        image: data.imgUrl
		};
		Jockey.on('shareBridge', function(payload, complete) {
		    complete(_data);
		});
	},
	onShare: function (callback) {
		Jockey.on('shareResultBridge', function(payload, complete) {
		    /*
		     *  payload
		     *
		     *  {
		     *      result: true    //分享成功
		     *      result: false   //分享失败
		     *  }
		     */
		});
	},
	/**
	 * 通过车牛协议打开VC的服务
	 */
	_openVC: function (data) {
		var d = $.Deferred();
		Jockey.send('OpenVCBridge', data, function(_data) {
	        d.resolve(_data);
		});
		return d;
	},
	/**
	 * 弹出当前VC，并push协议VC的服务
	 */
	_popAndPushVC: function (data) {
		var d = $.Deferred();
		Jockey.send('PopAndPushVCBridge', data, function(_data) {
	        d.resolve(_data);
		});
		return d;
	},
	/**
	 * 获取当前webVC的data数据
	 */
	_getWebVCData: function (data) {
		var d = $.Deferred();
		Jockey.send('GetWebVCDataBridge', data, function(_data) {
	        d.resolve(_data);
		});
		return d;
	},
	/**
	 * 出发当前WebVC的callback回调上一级页面
	 */
	// TriggleWebVCCallbackBridge
	
	/**
	 * 美图分享bridge，使用Jockey.on
	 */
	 // beautyBridge
	 
	 /**
	  * 自定义更多按钮bridge，使用Jockey.on
	  */
	 // moreInfoBridge
	 
	 /**
	  * 自定义更多按钮的点击回调brdige，使用Jockey.on
	  */
	 // moreActionBridge
	 
	 /**
	  * 设置viewcontroller的tag
	  */
	 // SetWebViewTag
	 
	 /**
	  * 堆栈管理
	  */
	 // StackManager
	
	/**
	 * 支付
	 */
	payment: function (orderCode, amount) {
		return this._openVC({
			protocol: 'cheniu://open.present/payment?orderCode=' + orderCode + '&amount=' + amount
		});
	},
	/**
	 * 优惠券
	 */
	coupon: function (biz_name, coupon_code) {
		return this._openVC({
			protocol: 'cheniu://open/use_coupon?biz_name=' + biz_name + '&coupon_code=' + coupon_code
		});
	},
	/**
	 * 原生车辆详情
	 */
	carDetail: function (carId) {
		return this._openVC({
			protocol: 'cheniu://open/carDetail?carId=' + carId
		});
	},
	/**
	 * 聊天窗口
	 */
	chat: function (userId) {
		return this.openVC({
			protocol: 'cheniu://open/chat?chatter=' + userId
		});
	},
	/**
	 * @deprecated
	 * 编辑店铺信息带店招
	 */
	editShopInfoWithShopsign: function (siteId, shopCode, shopSign) {
		var d = $.Deferred();
		Jockey.send('OpenVCBridge', {
            protocol: 'cheniu://open/shopInfo_edit?siteId=' + siteId
            	+ '&shopCode=' + shopCode
            	+ '&shopSign=' + shopSign
        }, function(data) {
        	// data.hasChangedInfo == 1
        	d.resolve(data);
        });
        return d;
	},
	/**
	 * @deprecated
	 * 编辑店铺信息
	 */
	editShopInfo: function () {
		var d = $.Deferred();
		Jockey.send('OpenVCBridge', {
			// 老版已弃用
			// cheniu://open/myDetailInfo
        	protocol: 'cheniu://open/myDataAndShopInfo'
        }, function (data) {
			d.resolve(data);
		});
		return d;
	},
	/**
	 * 编辑车行信息
	 */
	dealershipInfo: function () {
		var d = $.Deferred();
		Jockey.send('OpenVCBridge', {
			protocol: 'cheniu://open/dealershipInfo'
		}, function (data) {
			// alert(JSON.stringify(data));
			d.resolve(data);
		});
		return d;
	}
}

/**
 * 	- 协议
 * 		- 参数对象
 * 			- 特别属性
 */
// 打开方式为 open 
var _open = {
	// 车辆管理页面
	carManager: {},
	// webview页面
	webv: {
		// urlStr中包含的= ？& [ ] #必须转换成对应的%3D %3F %26 %5b %5d %23。
		url: {}
	},
	// 消息中心页面
	msgCenter: {},
	// 急求页面
	urgent: {},
	// 车源页面
	market: {
		// keywordStr为要搜索的关键字，汉字需要做urlencode
		keyword: {}
	},
	// 发车页面
	publish: {},
	// 我的购车贷订单List页面
	loanOrderList: {},
	// 我的购车贷订单detail页面
	loanDetail: {
		orderId: {}
	},
	// 我关注的车列表
	collectionList: {},
	// 车辆详情页
	carDetail: {
		carId: {}
	},
	// 拍卖场次页面
	auc_spot: {
		sessionId: {}
	},
	// 拍卖我上拍的车列表
	auc_onboard: {},
	// 拍卖关注列表
	auc_attention: {},
	// 拍卖车辆详情
	auc_aucdetail: {
		auctionId: {}
	},
	// 拍卖订单列表
	auc_order: {},
	// 拍卖订单详情页
	auc_orderdetail: {
		orderId: {}
	},
	// 优惠券列表
	couponList: {},
	// 我的买车订单list
	carBuyOrderList: {},
	// 我的卖车订单list
	carSellOrderList: {},
	// 我的车辆订单详情
	carOrderDetail: {
		orderCode: {},
		// roleStr为0表示买家，为1表示卖家
		roleType: {}
	}
}

// 打开方式为 open.present
var _open_present = {
	// 钱包页面
	// 必须采用present方式打开
	wallet: {}
}



//////////////////
// WEBPACK FOOTER
// ./~/@souche-f2e/myjockey/src/jockey__cheniu.js
// module id = 285
// module chunks = 4